import React, { useState, useEffect } from 'react';
import { DndProvider, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './TestPattern.css';
import QuestionCard from './QuestionCard';
import DraggableQuestionCard from './DraggableQuestionCard';

// Компонент корзины с поддержкой drop
const DropBasket = ({ children, onDrop }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'question',
    drop: (item) => onDrop(item.question),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div 
      ref={drop} 
      className={`TestBasket ${isOver ? 'drag-over' : ''}`}
    >
      {children}
    </div>
  );
};

const TestPattern = (props) => {
    const [testName, setTestName] = useState('');
    const [testDescription, setTestDescription] = useState('');
    const [questions, setQuestions] = useState([]);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [activeTypes, setActiveTypes] = useState({
        sociometry: false,
        leadership: false,
        belben: false
    });
    
    // Состояния для модального окна социометрии
    const [showSociometryModal, setShowSociometryModal] = useState(false);
    const [isParametric, setIsParametric] = useState(true);
    const [paramCount, setParamCount] = useState(1);

    // Загрузка вопросов
    useEffect(() => {
        const fetchQuestions = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    console.error('Токен авторизации не найден');
                    return;
                }

                const response = await fetch('http://185.250.149.189:8000/api/v1/Question', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                
                const data = await response.json();
                // Фильтруем только нужные типы вопросов
                const validQuestions = data.quests.filter(q => 
                    ['sociometry', 'leadership', 'belben'].includes(q.quest_type)
                );
                
                setQuestions(validQuestions);
                
            } catch (error) {
                console.error('Ошибка при получении вопросов:', error);
            }
        };

        fetchQuestions();
    }, []);

    // Обновляем активные типы при изменении выбранных вопросов
    useEffect(() => {
        const newActiveTypes = {
            sociometry: selectedQuestions.some(q => q.quest_type === 'sociometry'),
            leadership: selectedQuestions.some(q => q.quest_type === 'leadership'),
            belben: selectedQuestions.some(q => q.quest_type === 'belben')
        };
        setActiveTypes(newActiveTypes);
    }, [selectedQuestions]);

    // Обработчик для выбора/отмены всех вопросов типа
    const handleGroupSelect = (type) => {
        const typeQuestions = questions.filter(q => q.quest_type === type);
        const isTypeActive = activeTypes[type];
        
        if (isTypeActive) {
            // Удаляем все вопросы этого типа
            setSelectedQuestions(prev => prev.filter(q => q.quest_type !== type));
        } else {
            // Добавляем все вопросы этого типа
            const newQuestions = typeQuestions.filter(q => 
                !selectedQuestions.some(sq => sq.id === q.id)
            );
            setSelectedQuestions(prev => [...prev, ...newQuestions]);
        }
    };

    // Обработчик выбора вопроса
    const handleQuestionSelect = (question) => {
        if (!selectedQuestions.some(q => q.id === question.id)) {
            setSelectedQuestions(prev => [...prev, question]);
        }
    };

    // Обработчик удаления вопроса
    const handleQuestionDeselect = (questionId) => {
        setSelectedQuestions(prev => prev.filter(q => q.id !== questionId));
    };

    // Обработчик drop в корзину
    const handleDropToBasket = (question) => {
        if (!selectedQuestions.some(q => q.id === question.id)) {
            setSelectedQuestions(prev => [...prev, question]);
        }
    };

    // Обработчик сохранения
    const handleSave = async () => {
        const testData = {
            name: testName,
            description: testDescription,
            questions: selectedQuestions.map(q => ({
                id: q.id,
                title: q.title,
                quest_type: q.quest_type,
                data: q.data
            }))
        };
        
        // Проверяем наличие социометрических вопросов
        const hasSociometry = selectedQuestions.some(q => q.quest_type === 'sociometry');
        
        if (hasSociometry) {
            // Показываем модальное окно для выбора типа социометрии
            setShowSociometryModal(true);
        } else {
            // Если социометрии нет, сразу отправляем данные
            submitTestPattern(testData, true, 0);
        }
    };

    // Новая функция для отправки данных теста
    const submitTestPattern = async (testData, isParam, count) => {
        console.log('Данные теста для отправки:', JSON.stringify(testData, null, 2));
        
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('Токен авторизации не найден');
                alert('Ошибка авторизации! Пожалуйста, войдите снова.');
                return;
            }

            // 1. Получаем информацию о компании пользователя
            const companyResponse = await fetch('http://185.250.149.189:8000/api/v1/Company', {
                method: 'GET',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            // Обработка ответа компании
            let companyResponseText = await companyResponse.text();
            let companyData;
            try {
                companyData = JSON.parse(companyResponseText);
            } catch (e) {
                console.error('Ошибка парсинга ответа компании:', e);
                console.error('Ответ сервера:', companyResponseText);
                throw new Error(`Невалидный JSON в ответе компании: ${companyResponse.status}`);
            }
            
            if (!companyResponse.ok) {
                throw new Error(`Ошибка при получении компании: ${companyResponse.status} - ${JSON.stringify(companyData)}`);
            }
            
            console.log('Данные компании:', companyData);
            
            const companyId = companyData.Company?.id;
            if (!companyId) {
                throw new Error('Не удалось получить ID компании');
            }
            
            // 2. Формируем данные для отправки шаблона теста
            const postData = {
                name: testData.name,
                description: testData.description,
                is_param: isParam, // Используем выбранное значение
                param_count: count, // Используем выбранное количество
                company_id: companyId,
                questions: testData.questions
            };
            
            console.log('Данные для POST запроса:', JSON.stringify(postData, null, 2));
            
            // 3. Отправляем POST запрос с шаблоном теста
            const testResponse = await fetch('http://185.250.149.189:8000/api/v1/TestPatterns', {
                method: 'POST',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            });
            
            // Обработка ответа теста
            let testResponseText = await testResponse.text();
            let responseData;
            try {
                responseData = JSON.parse(testResponseText);
            } catch (e) {
                console.error('Ошибка парсинга ответа теста:', e);
                console.error('Ответ сервера:', testResponseText);
                throw new Error(`Невалидный JSON в ответе сохранения теста: ${testResponse.status}`);
            }
            
            if (!testResponse.ok) {
                throw new Error(`Ошибка при сохранении теста: ${testResponse.status} - ${JSON.stringify(responseData)}`);
            } else {
                console.log('Успешный ответ сервера:', responseData);
                alert('Тест успешно сохранен на сервере!');
                
                // Вызываем колбэк для возврата на страницу тестов
                if (props.onSaveSuccess) {
                props.onSaveSuccess();
                }
            }
            
        } catch (error) {
            console.error('Ошибка при сохранении теста:', error);
            alert(`Ошибка: ${error.message}`);
        }
    };

    // Обработчик подтверждения выбора типа социометрии
    const handleSociometryConfirm = () => {
        setShowSociometryModal(false);
        const testData = {
            name: testName,
            description: testDescription,
            questions: selectedQuestions.map(q => ({
                id: q.id,
                title: q.title,
                quest_type: q.quest_type,
                data: q.data
            }))
        };
        submitTestPattern(testData, isParametric, paramCount);
    };

    // Группировка вопросов по типам
    const getQuestionsByType = (type) => {
        return questions.filter(q => q.quest_type === type);
    };

    // Функция для получения русского названия типа
    const getTypeName = (type) => {
        switch(type) {
            case 'sociometry': return 'Социометрия';
            case 'leadership': return 'Лидерство';
            case 'belben': return 'Роль в команде';
            default: return type;
        }
    };

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="TestPattern"> 
                {/* Модальное окно для выбора типа социометрии */}
                {showSociometryModal && (
                    <div className="sociometry-modal-overlay">
                        <div className="sociometry-modal">
                            <h3>Выберите тип социометрического исследования</h3>
                            <p>В вашем тесте есть социометрические вопросы. Пожалуйста, выберите тип исследования:</p>
                            
                            <div className="sociometry-options">
                                <div 
                                    className={`sociometry-option ${isParametric ? 'selected' : ''}`}
                                    onClick={() => setIsParametric(true)}
                                >
                                    <h4>Параметрическое исследование</h4>
                                    <p>Количество выборов ограничено для всех участников</p>
                                    {isParametric && (
                                        <div className="param-count-selector">
                                            <label>Количество выборов:</label>
                                            <input
                                                type="number"
                                                min="1"
                                                max="5"
                                                value={paramCount}
                                                onChange={(e) => setParamCount(Math.max(1, Math.min(5, parseInt(e.target.value) || 1)))}
                                            />
                                        </div>
                                    )}
                                </div>
                                
                                <div 
                                    className={`sociometry-option ${!isParametric ? 'selected' : ''}`}
                                    onClick={() => setIsParametric(false)}
                                >
                                    <h4>Непараметрическое исследование</h4>
                                    <p>Количество выборов не ограничено</p>
                                </div>
                            </div>
                            
                            <div className="modal-buttons">
                                <button 
                                    className="cancel-button"
                                    onClick={() => setShowSociometryModal(false)}
                                >
                                    Отмена
                                </button>
                                <button 
                                    className="confirm-button"
                                    onClick={handleSociometryConfirm}
                                >
                                    Подтвердить
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                
                <div className="TestPatternHead"> 
                    <h1>Новый Тест</h1>
                    <button className="SaveButton" onClick={handleSave}>Сохранить</button>
                </div>
                
                <div className="TestPatternDescription"> 
                    <div className="TestName">
                        Название теста 
                        <textarea 
                            className='input1' 
                            name="test_name" 
                            placeholder="Введите название теста"
                            value={testName}
                            onChange={(e) => setTestName(e.target.value)}
                        ></textarea>
                    </div>
                    <div className="TestDes">
                        Описание теста
                        <textarea 
                            className='input2' 
                            name="test_Des" 
                            placeholder="Опишите тест"
                            value={testDescription}
                            onChange={(e) => setTestDescription(e.target.value)}
                        ></textarea>
                    </div>
                </div>
                
                <div className="TestQuest"> 
                    <div className="TestType"> 
                        <h2>Возможные вопросы</h2>
                        <div className="TestTypeInAll">
                            <div 
                                className={`TestTypeIn1 ${activeTypes.sociometry ? 'active' : ''}`}
                                onClick={() => setActiveTypes(prev => ({...prev, sociometry: !prev.sociometry}))}
                            >
                                Социометрия параметр.
                            </div>
                            <div 
                                className={`TestTypeIn2 ${activeTypes.sociometry ? 'active' : ''}`}
                                onClick={() => setActiveTypes(prev => ({...prev, sociometry: !prev.sociometry}))}
                            >
                                Социометрия непараметр.
                            </div>
                            <div 
                                className={`TestTypeIn3 ${activeTypes.leadership ? 'active' : ''}`}
                                onClick={() => setActiveTypes(prev => ({...prev, leadership: !prev.leadership}))}
                            >
                                Лидерство
                            </div>
                            <div 
                                className={`TestTypeIn4 ${activeTypes.belben ? 'active' : ''}`}
                                onClick={() => setActiveTypes(prev => ({...prev, belben: !prev.belben}))}
                            >
                                Роль в команде
                            </div>
                        </div>
                    </div>
                    <div className="TestNumber"> 
                        <h2>{selectedQuestions.length} вопросов в вашем тесте</h2>
                        <p>Добавьте в ваш тест вопросы из левого окна, перетащив их вправо или нажав на «+».
                            Чтобы убрать вопросы из теста, перетащите их влево или нажмите на «-».</p>
                    </div>
                </div>
                
                <div className="TestSelection"> 
                    <div className="TestShowcase"> 
                        {/* Группа социометрии */}
                        <div className="question-group">
                            <div className="group-header">
                                <h3>Социометрия:</h3>
                                <button 
                                    className={`group-btn ${activeTypes.sociometry ? 'remove' : 'add'}`}
                                    onClick={() => handleGroupSelect('sociometry')}
                                >
                                    {activeTypes.sociometry ? 'Удалить все' : 'Добавить все'}
                                </button>
                            </div>
                            <div className="questions-container">
                                {getQuestionsByType('sociometry').map(question => (
                                    <DraggableQuestionCard 
                                        key={question.id} 
                                        question={question} 
                                        isSelected={selectedQuestions.some(q => q.id === question.id)}
                                        onSelect={handleQuestionSelect}
                                    />
                                ))}
                            </div>
                        </div>
                        
                        {/* Группа лидерства - изменена: убраны индивидуальные карточки */}
                        <div className="question-group">
                            <div className="group-header">
                                <h3>Лидерство:</h3>
                                <button 
                                    className={`group-btn ${activeTypes.leadership ? 'remove' : 'add'}`}
                                    onClick={() => handleGroupSelect('leadership')}
                                >
                                    {activeTypes.leadership ? 'Удалить все' : 'Добавить все'}
                                </button>
                            </div>
                            <div className="questions-container">
                                {getQuestionsByType('leadership').map(question => (
                                    <div key={question.id} className="question-card static">
                                        <div className="question-content">
                                            <h4>{question.title}</h4>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        
                        {/* Группа роли в команде - изменена: убраны индивидуальные карточки */}
                        <div className="question-group">
                            <div className="group-header">
                                <h3>Роль в команде:</h3>
                                <button 
                                    className={`group-btn ${activeTypes.belben ? 'remove' : 'add'}`}
                                    onClick={() => handleGroupSelect('belben')}
                                >
                                    {activeTypes.belben ? 'Удалить все' : 'Добавить все'}
                                </button>
                            </div>
                            <div className="questions-container">
                                {getQuestionsByType('belben').map(question => (
                                    <div key={question.id} className="question-card static">
                                        <div className="question-content">
                                            <h4>{question.title}</h4>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                    <DropBasket onDrop={handleDropToBasket}> 
                        <h3>Выбранные вопросы</h3>
                        <div className="selected-questions">
                            {selectedQuestions.map(question => {
                                // Для вопросов лидерства и роли в команде показываем статические карточки без возможности удаления
                                if (question.quest_type === 'leadership' || question.quest_type === 'belben') {
                                    return (
                                        <div key={question.id} className="question-card static">
                                            <div className="question-content">
                                                <h4>{question.title}</h4>
                                            </div>
                                        </div>
                                    );
                                } else {
                                    // Для социометрии оставляем обычные карточки с возможностью удаления
                                    return (
                                        <QuestionCard 
                                            key={question.id} 
                                            question={question} 
                                            onDeselect={handleQuestionDeselect}
                                            isSelected={true}
                                        />
                                    );
                                }
                            })}
                        </div>
                    </DropBasket>    
                </div>
            </div>
        </DndProvider>
    )
}

export default TestPattern;